// @ flow
import React from "react"

const ZoomOut = () => {
  return (
    <svg className="Scooter-zoomIcon_out" x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512">
      <g>
        <g>
          <path
            className="iconPath"
            d="M506.142,477.851L361.69,333.399c65.813-80.075,61.335-198.944-13.451-273.73h-0.001
			c-79.558-79.559-209.011-79.558-288.569,0c-79.559,79.559-79.559,209.01,0,288.569c74.766,74.766,193.62,79.293,273.731,13.451
			l144.452,144.452c7.814,7.813,20.478,7.811,28.29,0C513.953,498.329,513.953,485.663,506.142,477.851z M319.949,319.948
			c-63.959,63.96-168.031,63.959-231.99,0c-63.96-63.96-63.96-168.03,0-231.99c63.958-63.958,168.029-63.961,231.99,0
			C383.909,151.918,383.909,255.988,319.949,319.948z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            className="iconPath"
            d="M301.897,183.95H106.01c-11.048,0-20.004,8.956-20.004,20.004c0,11.048,8.956,20.004,20.004,20.004h195.887
			c11.048,0,20.004-8.956,20.004-20.004C321.901,192.906,312.945,183.95,301.897,183.95z"
          />
        </g>
      </g>
    </svg>
  )
}

export default ZoomOut
